import { render, staticRenderFns } from "./KA1Config.vue?vue&type=template&id=4e28c37c&scoped=true"
import script from "./KA1Config.vue?vue&type=script&lang=js"
export * from "./KA1Config.vue?vue&type=script&lang=js"
import style0 from "./KA1Config.vue?vue&type=style&index=0&id=4e28c37c&prod&lang=css"
import style1 from "./KA1Config.vue?vue&type=style&index=1&id=4e28c37c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e28c37c",
  null
  
)

export default component.exports